export var RenditionStatus;
(function (RenditionStatus) {
    /**
     * Initial status
     */
    RenditionStatus[RenditionStatus["NotStarted"] = 0] = "NotStarted";
    RenditionStatus[RenditionStatus["Fetching"] = 1] = "Fetching";
    RenditionStatus[RenditionStatus["Done"] = 2] = "Done";
    /**
     * Occurs when there are any errors around fetching the
     * rendition from the service, AdobeAsset.clearRenditionError can
     * be used to clear the error and fetch again.
     */
    RenditionStatus[RenditionStatus["Error"] = 3] = "Error";
})(RenditionStatus || (RenditionStatus = {}));
export var RenditionSize;
(function (RenditionSize) {
    RenditionSize[RenditionSize["Size64"] = 64] = "Size64";
    RenditionSize[RenditionSize["Size128"] = 128] = "Size128";
    RenditionSize[RenditionSize["Size256"] = 256] = "Size256";
    RenditionSize[RenditionSize["Size512"] = 512] = "Size512";
    RenditionSize[RenditionSize["Size1024"] = 1024] = "Size1024";
})(RenditionSize || (RenditionSize = {}));
export var RenditionType;
(function (RenditionType) {
    RenditionType["PNG"] = "image/png";
    RenditionType["JPEG"] = "image/jpeg";
})(RenditionType || (RenditionType = {}));
